import { UserCardsPanel } from '@pesto/features/src/Cards/components/UserCardsPanel';
import { EntityEmptyState } from '@pesto/features/src/EntityProfile/components/EntityEmptyState';
import { CreditCard } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import type { UserCardListItem } from '../toUserDetail';

import { routes } from '../../../constants/routes';

interface UserCardsTabProps {
  cards: UserCardListItem[];
}

export const UserCardsTab = ({ cards }: UserCardsTabProps) => {
  const navigate = useNavigate();

  return (
    <UserCardsPanel
      cards={cards}
      onCardClick={(card) => navigate(routes.cards + '/' + card.id)}
      emptyState={<EntityEmptyState icon={CreditCard} title="This customer has no cards on file." />}
    />
  );
};
